import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { HostedpaymentDialogComponent } from '../model/hostedpayment-dialog/hostedpayment-dialog.component';
import { NotificationService } from './notification.service';
import { RestApiService } from './restapi.service';
import { UserService } from './user.service';
import { UniquePipe } from '../pipes/Unique.pipe';
import * as moment from 'moment';
import { UtilityService } from './utility.service';
import { CompanyService } from './company.service';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    public PaymentDataResponse: any = {};
    public PaymentTypeResponse: Array<any> = [];
    public selectedPaymentTypeName = '';
    public SelectedPaymentTypes: any = {};
    public OldSelectedPaymentType: any = {};
    public oldSelectedPaymentTypeName: string = '';
    public AllowedMethods = [];
    public SaveMethods = [];
    public IsFrameReload: boolean;
    userService: UserServiceModal;

    isModalOpen = false;
    constructor(public dialog: MatDialog, public notificationService: NotificationService, public user: UserService, public apiService: RestApiService, public utilityService: UtilityService, public companyService: CompanyService, public configService: ConfigService) {
        this.userService = user.userServiceModal;
    }

    public getPaymentType(checkFlow: boolean = false): Promise<Array<any>> {
        return new Promise((resolve, reject) => {
            const request = {
                countrycode: this.configService.commonData.selectedCountry || 'us',
            };
    
            const getPaymentTypePromise = this.apiService.getPaymentMerchants(request).toPromise()
                .then((result) => {
                    if (parseInt(result.Status, 10) === 0) {
                        this.PaymentTypeResponse['AllowedMethods'] = new UniquePipe().transform(result.Data, 'MerchantId');
                    } else {
                        this.notificationService.error('error_', result.Message);
                        throw new Error(result.Message);
                    }
                });

            const promises: Promise<any>[] = [getPaymentTypePromise];

            if(!checkFlow){
                const getCustomerSavedPaymentMethodPromise = this.apiService.getCustomerSavedPaymentMethods({
                    customerId: this.userService.customerData.CustomerId || this.PaymentDataResponse.customerId
                }).toPromise().then((result) => {
                    if (parseInt(result.Status, 10) === 0) {
                        this.PaymentTypeResponse['SaveMethods'] = new UniquePipe().transform(result.Data, 'PaymentMethodId');
                        this.userService.paymentMethods = this.PaymentTypeResponse['SaveMethods'];
                        sessionStorage.setItem("userService", JSON.stringify(this.userService));
                    } else {
                        this.notificationService.error('error_', result.Message);
                        throw new Error(result.Message);
                    }
                });
                promises.push(getCustomerSavedPaymentMethodPromise);
            }
    
            Promise.all(promises)
            .then(() => resolve(this.PaymentTypeResponse))
            .catch(error => reject(error));
        });
    }
    

    public getPaymentData(paymentdata?: any, paymentMethod: any = '', IsApplication: boolean = false) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.role = 'dialog';
        dialogConfig.width = '720px';
        const promise = new Promise((resolve, reject) => {
            const getPaymentDataRequest = {

                countrycode: this.configService.commonData.selectedCountry || 'us',
                merchantid: paymentdata.MerchantId || 0,
                // iframeid: 'DsIframe',
                // storeid: 0,
                // CountryCode: this.configService.commonData.selectedCountry || 'us',
                // region: this.companyService.getRegionID(this.configService.commonData.selectedCountry),
                // languagecode: this.configService.commonData.selectedLanguage || 'en',
                customerId: this.userService.customerData.CustomerId?this.userService.customerData.CustomerId : ""
            };
            this.apiService.getPaymentMethodIFrame(getPaymentDataRequest)
                .subscribe((result) => {
                    try {
                        if (Number(result.Status) === 0) {
                            const paymentData = result.Data;
                            this.PaymentDataResponse = paymentData;

                            const iframe = this.dialog.open(HostedpaymentDialogComponent, {
                                data: {
                                    IFrameUrl: paymentData,
                                    Width: paymentData.Width,
                                    Height: paymentData.Height,
                                    isCheckout: true
                                },
                                panelClass: 'hosted_payment-Dialog',
                            });
                            iframe.afterClosed().subscribe(res => {
                                if (res) {
                                    const newPayment: any = res;
                                    newPayment.MerchantId = paymentdata.MerchantId;
                                    if (!IsApplication && (!sessionStorage.getItem('guestLogin') || sessionStorage.getItem('guestLogin') == 'false')) {
                                        // this.savePaymentMethod(newPayment);
                                    }
                                    else {
                                        this.getPaymentType(IsApplication);
                                    }
                                    const paymentMethods = [];
                                    const editingPaymentMethod = paymentMethod;
                                    if (editingPaymentMethod) {
                                        paymentMethods.splice(paymentMethods.indexOf(editingPaymentMethod), 1, newPayment);
                                        this.userService.paymentMethods = paymentMethods;
                                    } else if (paymentMethods.length >= 2) {
                                        paymentMethods.splice(paymentMethods.indexOf(editingPaymentMethod), paymentMethods.length - 1, newPayment);
                                    } else {
                                        newPayment.CardType = newPayment.type;
                                        newPayment.Last4 = newPayment.lastFour;
                                        newPayment.ExpireMonth = newPayment.expireMonth;
                                        newPayment.ExpireYear = newPayment.expireYear;
                                        paymentMethods.push(newPayment);
                                        this.selectedPaymentTypeName = newPayment.CardType + ' ' + newPayment.Last4;
                                        this.userService.paymentMethods = paymentMethods;
                                    }
                                    this.userService.isPaymentChanged = true;
                                    sessionStorage.setItem('userService', JSON.stringify(this.userService));
                                    resolve(result);
                                }
                            });
                            iframe.afterOpened().subscribe(res => {
                                this.isModalOpen = true;
                            });
                        } else {
                            this.notificationService.error('error_', result.ErrorDescription);
                            reject(result);
                        }
                    } catch (ex) {

                        this.notificationService.error('error_', 'error_occured_try_again');
                        reject(ex);
                    }
                }, (error) => {
                    reject(error);
                }, () => {

                });
        });
        return promise;
    }

    public savePaymentMethod(payment) {
        const promise = new Promise((resolve, reject) => {
            const request = {
                customerId: 0,
                createPaymentMethod: {
                    MerchantId: payment.MerchantId || 99,
                    PaymentToken: payment.token,
                    CardType: payment.type,
                    NameOnAccount: payment?.billingInfo?.fullName || '',
                    Ending: payment.lastFour,
                    Expires: moment({ year: payment.expireYear, month: (parseInt(payment.expireMonth, 10) - 1), day: parseInt(moment().format('D'), 10) }).format(),
                    CurrencyCode: this.companyService.selectedCurrency.CurrencyCode
                }
            };
            this.apiService.createPaymentMethod(request).subscribe((response) => {
                const result = response.Data;
                if (response.Status.toString() !== '0') {
                    reject(response.ErrorDescription);
                    return;
                }
                this.getPaymentType();
                resolve(result);
            });
        });
        return promise;
    }

    public clearPayment() {
        this.PaymentDataResponse = {};
        this.PaymentTypeResponse = [];
        this.selectedPaymentTypeName = '';
        this.SelectedPaymentTypes = {};
        this.OldSelectedPaymentType = {};
        this.AllowedMethods = [];
        this.SaveMethods = [];
        sessionStorage.setItem('paymentService', JSON.stringify({}));
        localStorage.removeItem('paymentService'); // Clean up old localStorage
    }

}
